<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>

<script setup>
// Global error handler for currentRenderingInstance issues
const nuxtApp = useNuxtApp()

nuxtApp.hook('vue:error', (error, instance, info) => {
  console.error('Vue error caught:', error, info)
  
  // Handle specific currentRenderingInstance.ce error
  if (error.message && error.message.includes('currentRenderingInstance.ce')) {
    console.error('Detected currentRenderingInstance.ce error - this is a known Vue/Nuxt issue')
    // Attempt to reload the page as a recovery
    if (process.client) {
      window.location.reload()
    }
  }
})

// Additional error boundary
onErrorCaptured((err, instance, info) => {
  console.error('App error captured:', err, info)
  
  if (err.message && err.message.includes('currentRenderingInstance.ce')) {
    console.error('Attempting recovery from currentRenderingInstance error')
    return false
  }
  
  return false
})
</script>
